import { BomOutput, PartitionedBomGroup, StandardBomGroup } from "fond/types";
import { sum } from "fond/utils";

import { apiSlice } from "./apiSlice";

interface RawStandardBomOutput {
  groups: Omit<StandardBomGroup, "total">[];
}

interface RawPartitionedBomOutput {
  groups: Omit<PartitionedBomGroup, "total">[];
  partitions: { name: string }[];
}

/**
 * BOM API Slice
 */
export const bomSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getBomTemplateCategories: build.query({
      query: () => `/v2/bom-template-categories`,
    }),
    getVersionBom: build.query<BomOutput, string>({
      query: (versionId: string) => `/v2/versions/${versionId}/bom`,
      transformResponse: (response: RawStandardBomOutput | RawPartitionedBomOutput): BomOutput => {
        // Add group and overall totals to the response
        const groups = response.groups.map((group) => ({
          ...group,
          total: sum(group.ruleOutput.map((rule) => parseFloat(rule.total))),
        }));
        return {
          ...response,
          groups,
          total: sum(groups.map((group) => group.total)),
        };
      },
      providesTags: (_result, _error, versionId) => [{ type: "BOM", id: versionId }],
    }),
    regenerateBomCost: build.mutation<void, string>({
      query: (versionId: string) => ({ url: `/v2/versions/${versionId}/regenerate-cost`, method: "POST" }),
      invalidatesTags: (_result, _error, versionId) => [
        { type: "BOM", id: versionId },
        { type: "VersionStatus", id: versionId },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useGetBomTemplateCategoriesQuery, useGetVersionBomQuery, useRegenerateBomCostMutation } = bomSlice;
